// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1175":"a2ee57f2eae61c4e","1360":"96c0497b999cc8a6","3114":"9f8b2f1c98e70014","7077":"da55a4e65d68473d","8670":"e26e1e49f7aa3e97","9528":"7278c175e4ec2586"}[chunkId] + ".js";
};